import Hero from "./components/Hero";
import FeedArea from "./components/FeedArea";
import CategoryRail from "./components/CategoryRail";
import SpecialShowcase from "./components/SpecialShowcase";
import FaqSection from "./components/FaqSection";
import AboutContact from "./components/AboutContact";
import { FAQS, SITE } from "@/mocks/gossip";

export default function HomePage() {
  const faqLd = {
    "@context": "https://schema.org",
    "@type": "FAQPage",
    mainEntity: FAQS.map((f) => ({
      "@type": "Question",
      name: f.q,
      acceptedAnswer: { "@type": "Answer", text: f.a },
    })),
  };

  const orgLd = {
    "@context": "https://schema.org",
    "@type": "Organization",
    name: SITE.name,
    url: "https://199695.cn/",
    description: SITE.desc,
    email: SITE.email,
  };

  const siteLd = {
    "@context": "https://schema.org",
    "@type": "WebSite",
    name: SITE.name,
    url: "https://199695.cn/",
    inLanguage: "zh-CN",
    description: SITE.desc,
  };

  return (
    <>
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(siteLd) }}
      />
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(orgLd) }}
      />
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(faqLd) }}
      />
      <Hero />
      <FeedArea />
      <CategoryRail />
      <SpecialShowcase />
      <FaqSection />
      <AboutContact />
    </>
  );
}